import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=23983d6b&scoped=true"
import script from "./EditorHeader.vue?vue&type=script&lang=ts"
export * from "./EditorHeader.vue?vue&type=script&lang=ts"
import style0 from "./EditorHeader.vue?vue&type=style&index=0&id=23983d6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23983d6b",
  null
  
)

export default component.exports